import React, { ReactNode } from 'react'
import { LayoutBasic } from './index'

interface DirectOutreachLayoutBasicProps {
  header?: ReactNode
  withMaxWidth?: boolean
}

export const DirectOutreachLayoutBasic: React.FC<React.PropsWithChildren<DirectOutreachLayoutBasicProps>> = ({
  children,
  header,
  withMaxWidth = true,
}) => {
  return (
    <LayoutBasic header={header} withMaxWidth={withMaxWidth} disablePrivacyPolicy disableTermsAndConditions>
      {children}
    </LayoutBasic>
  )
}
